export const Props = () => ({
  //--------------------------------------------------------------------------
  //                              Объект поста Альфы
  //--------------------------------------------------------------------------
  post: {
    type: Object,
    required: false,
  },
  //xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx

  //--------------------------------------------------------------------------
  //                                 ID поста
  //--------------------------------------------------------------------------
  postId: {
    type: [Number, String],
    required: false,
  }
  //xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx
});